import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

const Err404 = () => import("@/views/error/Err404");
const ErrorLog = () => import("@/components/ErrorLog/Index");
const Home = () => import("@/views/Home/home");
const Contact = () => import("@/views/contact/contact");
const News = () => import("@/views/news/news");
const NewDetail = () => import("@/views/news/newDetail");
const Cases = () => import("@/views/case/case");
const CaseDetail = () => import("@/views/case/caseDetail");
const Company = () => import("@/views/about/company");
const productChip = () => import("@/views/product/productChip");
const productChip1 = () => import("@/views/product/productChip1");
const Resale = () => import("@/views/resale/index");
const Study = () => import("@/views/study/index");

/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:'true'` will not show in the sidebar
 * redirect : if `redirect:noredirect` will no redirct in the levelbar
 * noDropdown : if `noDropdown:'true'` will has no submenu
 * meta : { role: ['admin'] }  will control the page role
 **/

export const constantRouterMap = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: null,
    icon: "",
    redirect: null
  },
  {
    path: "/contact",
    name: "contact",
    component: Contact,
    meta: null,
    icon: "",
    redirect: null
  },
  {
    path: "/news",
    name: "news",
    component: News,
    meta: null,
    icon: "",
    redirect: null
  },
  {
    path: "/newDetail",
    name: "newDetail",
    component: NewDetail,
    meta: null,
    icon: "",
    redirect: null
  },
  {
    path: "/cases",
    name: "cases",
    component: Cases,
    meta: null,
    icon: "",
    redirect: null
  },
  {
    path: "/caseDetail",
    name: "caseDetail",
    component: CaseDetail,
    meta: null,
    icon: "",
    redirect: null
  },
  {
    path: "/company",
    name: "company",
    component: Company,
    meta: null,
    icon: "",
    redirect: null
  },
  {
    path: "/productChip",
    name: "productChip",
    component: productChip,
    meta: null,
    icon: "",
    redirect: null
  },
  {
    path: "/productChip1",
    name: "productChip1",
    component: productChip1,
    meta: null,
    icon: "",
    redirect: null
  },
  {
    path: "/resale",
    name: "resale",
    component: Resale,
    meta: null,
    icon: "",
    redirect: null
  },
  {
    path: "/study",
    name: "study",
    component: Study,
    meta: null,
    icon: "",
    redirect: null
  }
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});

export const asyncRouterMap = [];



// WEBPACK FOOTER //
// ./src/router/index.js